module.exports = __webpack_public_path__ + "img/IMG_4215_L_Wood.338ba5d0.jpg";